<div class="scheduled-messages-modal">
    <div class="modal-header d-flex justify-content-between align-items-center">
        <h5 class="mb-0 fw-bold">Scheduled messages</h5>
        <button type="button"
                class="btn-close"
                (click)="close()"
                aria-label="Close">
            <img src="assets/common/ic_x_s_size.svg" alt="Close" />
        </button>
    </div>

    <div class="modal-body">
        <div *ngIf="!scheduledMessages || scheduledMessages.length === 0"
             class="empty-state">
            <p>No scheduled messages.</p>
        </div>

        <div *ngIf="scheduledMessages && scheduledMessages.length > 0"
             class="scheduled-list">
            <div *ngFor="let scheduled of scheduledMessages"
                 class="scheduled-card">
                <div class="scheduled-main">
                    <div class="scheduled-datetime">
                        {{ (scheduled.scheduled_at || scheduled.created_at) | dateFormat:'EEE, MMM d y' }}
                        at
                        {{ (scheduled.scheduled_at || scheduled.created_at) | dateFormat:'h:mm a' }}
                    </div>
                    <div class="scheduled-text">
                        {{ scheduled.message || 'Scheduled message' }}
                    </div>
                </div>
                <div class="scheduled-actions">
                    <button type="button"
                            class="btn-icon-sm"
                            title="Edit message"
                            (click)="handleEdit(scheduled)">
                        <img src="assets/common/ic_edit.svg" alt="Edit">
                    </button>
                    <button type="button"
                            class="btn-icon-sm"
                            title="Reschedule"
                            (click)="handleReschedule(scheduled)">
                        <img src="assets/common/ic_calendar_s_size.svg" alt="Reschedule">
                    </button>
                    <button type="button"
                            class="btn-icon-sm"
                            title="Delete"
                            (click)="handleDelete(scheduled)">
                        <img src="assets/common/ic_delete_destructive_s_size.svg" alt="Delete">
                    </button>
                </div>
            </div>
        </div>
    </div>
</div>

